import { slicedToArray as _slicedToArray, toConsumableArray as _toConsumableArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import { usePathContext } from '../../../../context/PathContext.js';
import 'classnames';
import { ListPathQuestionSchemaType } from '../../../../generated/types.js';
import DefaultCard from '../../../SelectCard/DefaultCard/index.js';
import ImageSelectCard from '../../../SelectCard/ImageCard/index.js';
import styles from './styles.css.js';

var SelectList = function SelectList(_ref) {
  var question = _ref.question,
      loading = _ref.loading,
      onQuestionUpdated = _ref.onQuestionUpdated,
      onQuestionValidityChanged = _ref.onQuestionValidityChanged;
  var pathContext = usePathContext();
  var listQuestion = question; // This component is constrained to single and multi select questions only

  var isSingleSelect = listQuestion.listSchemaType === ListPathQuestionSchemaType.SINGLE_SELECT_LIST;
  var initialListChoices = listQuestion.choices.filter(function (choice) {
    return !!choice.selected;
  }).map(function (choice) {
    return choice.id;
  });

  var _useState = useState(initialListChoices),
      _useState2 = _slicedToArray(_useState, 2),
      selectedChoices = _useState2[0],
      updateSelectedChoices = _useState2[1];

  useEffect(function () {
    if (initialListChoices.length > 0) {
      populateListChoices(initialListChoices);
      onQuestionValidityChanged(true);
    }
  }, []);
  var containerColumnClass = '';
  var choiceColumnClass = ''; // Modal placement treats all themes as a mobile breakpoint

  if (pathContext.pathPlacement === 'modal') {
    containerColumnClass = styles.container;
    choiceColumnClass = styles.choiceTwo;
  } else {
    switch (listQuestion.choices.length) {
      case 2:
        containerColumnClass = styles.containerTwo;
        choiceColumnClass = styles.choiceTwo;
        break;

      case 3:
        containerColumnClass = styles.containerThree;
        choiceColumnClass = styles.choiceThree;
        break;

      case 4:
      default:
        containerColumnClass = styles.containerFour;
        choiceColumnClass = styles.choiceFour;
        break;
    }
  }

  var handleChange = function handleChange(_ref2) {
    var choiceId = _ref2.choiceId,
        isChecked = _ref2.isChecked;

    var _a;

    var updatedChoices = [];

    if (isSingleSelect) {
      // Update both the state and fire the callback here, we don't use the state
      // in the callback so we don't have to deal with the async state update
      updateSelectedChoices([choiceId]);
      onQuestionUpdated({
        id: (_a = pathContext.activeNode) === null || _a === void 0 ? void 0 : _a.id,
        listQuestion: {
          questionId: question.id,
          values: [choiceId]
        }
      });
      populateListChoices([choiceId]);
    } else {
      if (!isChecked) {
        var updatedChoicesWithRemoved = _toConsumableArray(selectedChoices).filter(function (choiceIdToRemove) {
          return choiceIdToRemove !== choiceId;
        });

        updatedChoices = updatedChoicesWithRemoved;
      } else if (isChecked && !selectedChoices.includes(choiceId)) {
        updatedChoices = [].concat(_toConsumableArray(selectedChoices), [choiceId]);
      }

      updateSelectedChoices(updatedChoices);
      populateListChoices(updatedChoices);
    }
  };

  var populateListChoices = function populateListChoices(updatedChoices) {
    var _a;

    onQuestionUpdated({
      id: (_a = pathContext.activeNode) === null || _a === void 0 ? void 0 : _a.id,
      listQuestion: {
        questionId: question.id,
        values: updatedChoices || []
      }
    });
    onQuestionValidityChanged(question.commonFields.required ? updatedChoices.length > 0 : true);
  };

  return React.createElement("div", {
    className: containerColumnClass,
    "data-testid": "path-select-list-container"
  }, listQuestion.choices.map(function (choice) {
    return React.createElement("div", {
      className: choiceColumnClass,
      key: choice.id
    }, choice.primaryImage ? React.createElement(ImageSelectCard, {
      disabled: loading,
      image: choice.primaryImage,
      question: listQuestion,
      choice: choice,
      isSelected: selectedChoices.includes(choice.id),
      onHandleChange: handleChange
    }) : React.createElement(DefaultCard, {
      disabled: loading,
      question: listQuestion,
      choice: choice,
      isSelected: selectedChoices.includes(choice.id),
      onHandleChange: handleChange
    }));
  }));
};

export default SelectList;
//# sourceMappingURL=index.js.map
